import { registerFeatureWithDescription } from "lib/features"
import { CATEGORY_MAINTENANCE_REGIMES } from "lib/feature-category"
import { REGIME_SCHEDULE_COUNTS_FEATURE } from "./regime-schedule-counts-constants.mjs"

export const FEATURE_FLAG_REGIME_SCHEDULE_COUNTS = registerFeatureWithDescription({
    numericalId: 2148,
    id: REGIME_SCHEDULE_COUNTS_FEATURE,
    name: "Regime schedule totals",
    internalUseOnly: true,
    readyForBeta: false,
    readyForProduction: false,
    category: CATEGORY_MAINTENANCE_REGIMES,
    descriptionLines: [
        "Show a regime's total schedule entries in its page heading and in the Maintenance Regimes list.",
    ],
})
